export type CalculateFestivalEss = {
  scoreLetter: string;
  score: number;
  maxScore: number;
  topics: {
    PARITY_EQUALITY: {
      score: number;
      maxScore: number;
      sections: {
        ARTISTIC_TEAM: { score: number; maxScore: number };
        PERMANENT_OPERATIONAL_TEAM: { score: number; maxScore: number };
        OCCASIONAL_OPERATIONAL_TEAM: { score: number; maxScore: number };
        TRANSPARENCY_MANAGEMENT: { score: number; maxScore: number };
      };
    };
    ACCESSIBILITY_SOCIAL_DIALOGUE: {
      score: number;
      maxScore: number;
      sections: {
        ACCESSIBILITY: { score: number; maxScore: number };
        RISK_PREVENTION: { score: number; maxScore: number };
        VOLUNTEERS: { score: number; maxScore: number };
        COMMUNICATION: { score: number; maxScore: number };
        TEAM_MANAGEMENT: { score: number; maxScore: number };
      };
    };
    LOCAL_IMPACT_RSE_ENGAGEMENT: {
      score: number;
      maxScore: number;
      sections: {
        LOCALITY_EMPLOYMENT_PARTNERS: { score: number; maxScore: number };
        ECONOMIC_SOCIAL_IMPACT: { score: number; maxScore: number };
      };
    };
  };
  sectors: {
    ANY: { score: number; maxScore: number };
    ARTISTS: { score: number; maxScore: number };
    PUBLIC: { score: number; maxScore: number };
    SITE: { score: number; maxScore: number };
    TEAM: { score: number; maxScore: number };
  };
};

export const EMPTY_CALCULATE_FESTIVAL_ESS: CalculateFestivalEss = {
  scoreLetter: '-',
  score: 0,
  maxScore: 0,
  topics: {
    PARITY_EQUALITY: {
      score: 0,
      maxScore: 0,
      sections: {
        ARTISTIC_TEAM: { score: 0, maxScore: 0 },
        PERMANENT_OPERATIONAL_TEAM: { score: 0, maxScore: 0 },
        OCCASIONAL_OPERATIONAL_TEAM: { score: 0, maxScore: 0 },
        TRANSPARENCY_MANAGEMENT: { score: 0, maxScore: 0 },
      },
    },
    ACCESSIBILITY_SOCIAL_DIALOGUE: {
      score: 0,
      maxScore: 0,
      sections: {
        ACCESSIBILITY: { score: 0, maxScore: 0 },
        RISK_PREVENTION: { score: 0, maxScore: 0 },
        VOLUNTEERS: { score: 0, maxScore: 0 },
        COMMUNICATION: { score: 0, maxScore: 0 },
        TEAM_MANAGEMENT: { score: 0, maxScore: 0 },
      },
    },
    LOCAL_IMPACT_RSE_ENGAGEMENT: {
      score: 0,
      maxScore: 0,
      sections: {
        LOCALITY_EMPLOYMENT_PARTNERS: { score: 0, maxScore: 0 },
        ECONOMIC_SOCIAL_IMPACT: { score: 0, maxScore: 0 },
      },
    },
  },
  sectors: {
    ANY: { score: 0, maxScore: 0 },
    ARTISTS: { score: 0, maxScore: 0 },
    PUBLIC: { score: 0, maxScore: 0 },
    SITE: { score: 0, maxScore: 0 },
    TEAM: { score: 0, maxScore: 0 },
  },
};
